//https://www.youtube.com/watch?v=u3KlatzB7GM
import {createSlice} from "@reduxjs/toolkit";

//  this showed how to create the reducer
// https://stackoverflow.com/questions/68971771/react-redux-toolkit-action-in-dispatch-returns-err-object-is-not-a-functi

// const initialState = {value: {id: 0, mcode: "", name:"", description: ""}};

export const owedSlice = createSlice({
    name: 'owedSlc',
    initialState: {value: {
            myProductId: null, myGuildId: null, myR2m: null, myCdpId: null,
            updateOwedGrid: false, owedGridState: true, owedFetchState: false, owedNewStatus: null,
            approvedState: false,  rejectedState: false,  flagState: false,  holdState: false, paidState: false, issuedState: false,
            deferState: false, unapproveState: false}},
    reducers:
        // {
        //     changeOwed: (state, action) => {
        //         state.value = action.payload;
        //     },
        // }
{
    changeOwed: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const {changeOwed} = owedSlice.actions;

export default  owedSlice.reducer ;
